import MastheadHeader from './components/MastheadHeader';
import Hero from './components/Hero';
import Featured from './components/Featured';
import Collections from './components/Collections';
import HotTopics from './components/HotTopics';
import Updates from './components/Updates';
import GuideTips from './components/GuideTips';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 text-foreground-950">
      <MastheadHeader />
      <main className="flex-1">
        <Hero />
        <Featured />
        <Collections />
        <HotTopics />
        <Updates />
        <GuideTips />
      </main>
      <SiteFooter />
    </div>
  );
}